const actionTypes = {
    SET_NTH_BRAND: 'SET_NTH_BRAND',
    SET_NTH_BRAND_FULFILLMENT_OPTIONS: 'SET_NTH_BRAND_FULFILLMENT_OPTIONS'
};

module.exports = actionTypes;
